<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col >
          <b-card>
            <div slot="header" >
              <strong>Create Withdraw</strong>
            </div>

            <div class="wapper_header">
              <div class="text-center mb-5">
                <img src="../../../public/img/logo-mfu.png" alt="" height="100px" class="mb-1">
                <p>{{this.title}}</p>
              </div>
            </div>

            <b-row>
              <b-col md="6" sm="12"><p>{{this.studentInfo.ACDTEXT}}</p></b-col>
              <b-col md="6" sm="12"><p>{{this.studentInfo.FACULTYNAME}}</p></b-col>
            </b-row>

            <b-row>
              <b-col md="6" sm="12"><p>Student Code : {{this.studentInfo.STUDENTCODE}}</p></b-col>
              <b-col md="6" sm="12"><p>{{this.studentInfo.DEPARTMENTNAME}}</p></b-col>
            </b-row>

            <b-row>
              <b-col md="6" sm="12"><p>Student Name : {{this.studentInfo.STUDENTNAME}}</p></b-col>
              <b-col md="6" sm="12">
                <b-form-group
                  label="Mobile"
                  label-for="mobile"
                  :label-cols="2"
                  :horizontal="true">
                  <b-form-input id="mobile" type="text" autocomplete="mobile" v-model="studentInfo.PHONENO"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="6" sm="12"><p>GPA : {{this.studentInfo.GPAX}}</p></b-col>
              <b-col md="6" sm="12">
                <b-form-group
                  label="E-mail"
                  label-for="e-mail"
                  :label-cols="2"
                  :horizontal="true">
                  <b-form-input id="email" type="text" autocomplete="email" v-model="studentInfo.EMAIL"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-table class="table-outline" responsive="sm":items="tableItems" :fields="tableFields" head-variant="light">
              <div slot="id" slot-scope="item" @click="onSelect(item)">
                <i class="fa fa-square-o fa-lg" v-if="item.value != true"></i>
                <i class="fa fa-check-square-o fa-lg" v-if="item.value == true"></i>
              </div>

              <div slot="reason" slot-scope="item">

                <b-form-input id="reason" type="text" autocomplete="reason"  v-model="item.item.reason"  placeholder="Enter your message"></b-form-input>
<!--                <b-form-input id="reason" type="text" autocomplete="reason"  @change="signalChange(item,$event)"  placeholder="Enter your message"></b-form-input>-->
              </div>
            </b-table>

            <div slot="footer" class="text-right">
              <b-button size="gl" variant="primary" @click="this.createData" class="mr-sm-1"><i class="fa fa-dot-circle-o"></i> Submit</b-button>
              <b-button size="gl" variant="danger" @click="this.clearData"><i class="fa fa-ban"></i> Reset</b-button>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <b-modal
        :header-bg-variant="this.dialog.type"
        header-text-variant="light"
        :class="this.dialog.style"
        v-model="this.dialog.status"
        @ok="actionDialog()"
        :ok-variant="this.dialog.type"
        ok-only>
        {{this.dialog.message}}
      </b-modal>

    </div>
  </div>
</template>

<script>


  import Service from "../../service/api"
  export default {
    name: 'CreateWithdrow',
    data () {
      return {
        title:"DIVISION OF REGISTRAR, MAE FAH LUANG UNIVERSITY",
        dialog : {
          message : '',
          type : 'danger',
          style : 'modal-danger',
          status : false,

        },
        studentInfo:{},
        tableFields: {
          id: {
            label: 'Select',
            class: 'text-center'
          },
          COURSECODE: {
            label: 'Course Code',
            class: 'text-center'
          },
          COURSENAME: {
            label: 'Course Title',
            class: 'text-left'
          },
          SECTION: {
            label: 'Section',
            class: 'text-center'
          },
          CREDITTOTAL: {
            label: 'Credit',
            class: 'text-center'
          },
          reason: {
            label: 'Reason',
            class: 'text-center'
          },
//          actionn: {
//            label: 'Action',
//            class: 'text-center'
//          }
        },
        reason:'',
        tableItems:[],
        events: []
      }
    },

    methods: {
      onLoad(){
        Service.onStudentinfo().then((response) => {
          this.studentInfo = response.data.data[0];
          this.onLoad_Result();
        }).catch((error) => {
        });
      },
      onLoad_Result(){
        Service.onStudentCourse(this.studentInfo.CURRENT_ACADYEAR,this.studentInfo.CURRENT_SEMESTER).then((response) => {
          var info = response.data.data;
          this.tableItems = []
          for(var i=0; i<info.length; i++){

            info[i].id = false;
            info[i].reason = "";
            this.tableItems.push(info[i])

          }


        }).catch((error) => {
        });
      },

      onSelect(item){

        for(var i=0; i<this.tableItems.length; i++){
          if(this.tableItems[i].CLASSID == item.item.CLASSID){
            this.tableItems[i].id = (item.item.id == true)?false:true
          }
        }
      },


      signalChange: function(item,evt) {
        for(var i=0; i<this.tableItems.length; i++){
          if(this.tableItems[i].CLASSID == item.item.CLASSID){
            this.tableItems[i].reason = evt
          }
        }
      },

      createData(){

        var itemWithdraw = [];
        for(var i=0; i<this.tableItems.length; i++){
          var info = this.tableItems[i];
          var item = {};
          item.studentcode = info.STUDENTCODE;
          item.acadyear = info.ACADYEAR;
          item.semester = info.SEMESTER;
          item.classid = info.CLASSID;
          item.courseid = info.COURSEID;
          item.reason = info.reason;
          item.mobile = this.studentInfo.PHONENO;
          item.email = this.studentInfo.EMAIL;

          if(info.id == true){
            itemWithdraw.push(item);
          }
        }

        var body = {};
        body.data = itemWithdraw;

        Service.onStudentCreateWithdraw(body).then((response) => {

          switch (response.data.code){
            case 200:
              this.onLoad_Result();
              this.dialog =  {
                message : response.data.message,
                type : 'success',
                style : 'modal-success',
                status : true,
              }
              break
            default:
              this.dialog =  {
                message : response.data.message,
                type : 'danger',
                style : 'modal-danger',
                status : true,
              }
              break
          }


        }).catch((error) => {
          this.dialog =  {
            message : error.response.data.message,
            type : 'danger',
            style : 'modal-danger',
            status : true,
          }
        });
      },
      actionDialog(){
        this.dialog = {
          status : false
        }
      },

    },
    mounted() {

    },
    created () {
      this.onLoad();

    },
  }

</script>
<style>
</style>
